import {
  InputField,
  EfsMelcoEfsModelsSchemaListItem,
} from "melco-shared-logic";
import { useCustomTokenField } from "../../hooks/inputFormats/useCustomTokenField";

type ProcessingConditionCustomTokenFieldProps = {
  idx: number;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export const ProcessingConditionCustomTokenField: React.FC<
  ProcessingConditionCustomTokenFieldProps
> = ({ idx, dataAssignments }) => {
  const isCustomTokenFieldEnabled = useCustomTokenField(
    dataAssignments,
    `conditions[${idx}].format_detail_id`
  );

  if (!isCustomTokenFieldEnabled) {
    return null;
  }

  return <InputField name={`conditions[${idx}].xpath_token`} />;
};
